import axios from 'axios'
import {useChatSessionStore} from "@src/stores/chatSession";
import {useMessages} from "@src/composables/useMessages";
import {db} from "@src/services/db";

const {deleteMessage} = useMessages()

class MessageService {

    async getSessionMessagesOld(sessionId: number, oldestId: number | null = null) {
        try {
            let url = `/operator/v4/sessions/${sessionId}/messages`;
            if (oldestId) {
                url += `/${oldestId}`;
            }

            const response = await axios.get(url, {
                withCredentials: true,
            });

            return response.data;
        } catch (e) {
            console.error("❌ Erro ao buscar histórico da sessão", e);
            return null;
        }
    }

    async sendMessage(message: any, tempId: string, reply: number | null | string) {
        const sessionStore = useChatSessionStore();
        return this.sendMessageToSession(
            Number(sessionStore.selectedSession?.id),
            message,
            tempId,
            reply
        );
    }

    async sendMedia(message: FormData, forbidden: boolean = false) {
        const sessionStore = useChatSessionStore();
        sessionStore.openAttachSelector = false;
        return this.sendMediaToSession(
            Number(sessionStore.selectedSession?.id),
            message,
            forbidden
        );
    }

    async sendContact(contactId: number, quotedId: number | string) {
        const sessionStore = useChatSessionStore();
        return this.sendContactToSession(
            Number(sessionStore.selectedSession?.id),
            contactId,
            quotedId
        );
    }

    async sendLocation(locationId: number, quotedId: number) {
        const sessionStore = useChatSessionStore();
        return this.sendLocationToSession(
            Number(sessionStore.selectedSession?.id),
            locationId,
            quotedId
        );
    }

    async getLinkData(url: string) {
        try {
            const response = await axios.get('api/link-preview?url=' + url,
                {withCredentials: true})
            return response.data
        } catch (e) {
        }
    }

    async deletedMessage(message: number) {
        try {
            await axios.post('operator/v4/message/delete', {
                'message': message,
            })

            await deleteMessage(message)

        } catch (e) {
            console.error(e)
        }
    }

    async submitComment(comment: FormData) {
        try {
            await axios.post('operator/v4/comment', comment, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            })
        } catch (e) {
            console.error('Erro ao criar comentario:', e)
        }
    }

    editMessage(messageId: number | string, newMessage: string) {
        return axios.post('/operator/v4/message/edit', {
            'message': messageId,
            'text': newMessage
        });
    }

    async sendMessageToSession(
        sessionId: number,
        message: string,
        tempId: string | number,
        reply: number | null | string
    ) {
        try {
            const response = await axios.post('operator/v4/message/text', {
                session: sessionId,
                message,
                quoted: reply,
            });

            response.data.message.message = message;

            await db.messages.put(response.data.message);
            await db.sessions
                .where('id')
                .equals(response.data.message.chat_session_id)
                .modify({
                    last_message: response.data.message
                });

            return response.data.message;
        } catch (e) {
            console.error(e);
            throw e;
        }
    }

    async sendMediaToSession(sessionId: number, message: FormData, forbidden: boolean = false) {
        try {
            const response = await axios.post(
                'operator/v4/message/' + message.get('type') + '/' + sessionId + (forbidden ? '/' + forbidden : ''),
                message,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }
            );
            if (forbidden) {
                return true
            }
            if (response.data.data.group_id) {
                db.group_messages.put(response.data.data)
                db.groups.where('id')
                    .equals(response.data.data.group_id)
                    .modify({
                        last_message: response.data.data.content
                    });
            } else {
                await db.messages.put(response.data.data);
                await db.sessions
                    .where('id')
                    .equals(response.data.data.chat_session_id)
                    .modify({
                        last_message: response.data.data
                    });
            }
            return response.data.data;
        } catch (e) {
            console.error(e);
            throw e;
        }
    }

    async sendContactToSession(sessionId: number, contactId: number, quotedId: number | string) {
        try {
            const response = await axios.post(
                'operator/v4/message/contact',
                {
                    session: sessionId,
                    contact: contactId,
                    quoted: quotedId,
                },
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }
            );

            await db.messages.put(response.data.message);
            await db.sessions
                .where('id')
                .equals(response.data.message.chat_session_id)
                .modify({
                    last_message: response.data.message
                });

            return response.data.message;
        } catch (e) {
            console.error(e);
            throw e;
        }
    }

    async sendLocationToSession(sessionId: number, locationId: number, quotedId: number) {
        try {
            const response = await axios.post(
                'operator/v4/message/location',
                {
                    location: locationId,
                    session: sessionId,
                    quoted: quotedId
                }
            );

            await db.messages.put(response.data.message);
            await db.sessions
                .where('id')
                .equals(response.data.message.chat_session_id)
                .modify({
                    last_message: response.data.message
                });

            return response.data.message;
        } catch (e) {
            console.error(e);
            throw e;
        }
    }
}

export default new MessageService()